import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=67bc0f84&scoped=true"
import script from "./Landing.vue?vue&type=script&setup=true&lang=ts"
export * from "./Landing.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Landing.vue?vue&type=style&index=0&id=67bc0f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bc0f84",
  null
  
)

export default component.exports